module.exports = __webpack_public_path__ + "static/babyscanmain-e657f871b750df149c58897a6f1c192f.jpeg";